import React from "react";

const Banner = () => {
  return (
    <div className="hidden h-full w-1/2 justify-center overflow-y-auto bg-purple-D0B4FF px-8 pb-4 md:flex">
      <div className="my-auto flex-col items-center text-center">
        <img alt="business" src="/images/business.svg" className="mt-32" />
        <div className="mt-20 font-MontserratSemiBold text-ft24 text-purple-6C36B0">
          Data Privacy, Evolved
        </div>
        <div className="mt-7 font-MontserratMedium text-ft18 text-white">
          Revolutionizing Data Consent Management and Sharing
        </div>
      </div>
    </div>
  );
};

export default Banner;
